import { createContext, useContext, useState } from "react";

export const LANGS = [
  { code: "fr", label: "FR" },
  { code: "en", label: "EN" },
  { code: "nl", label: "NL" },
];

const fr = {
  nav: { soins: "Soins", machine: "Auraskin Gold", resultats: "Résultats", tarifs: "Tarifs", dispos: "Disponibilités", contact: "Contact", reserver: "Réserver" },
  hero: {
    kicker: "Centre d'Esthétique — Épilation & Regard",
    l1: "Révéler", l2: "votre peau,", l3: "sans compromis.",
    sub: "Épilation laser définitive avec Auraskin Gold — la référence absolue du moment — électrolyse, réhaussement de cil et brow lift, dans un cocon de douceur.",
    cta1: "Réserver un rendez-vous", cta2: "Découvrir les soins",
    badgeTitle: "Auraskin Gold", badgeSub: "La meilleure machine du moment",
  },
  marquee: { items: ["Épilation Laser Diode", "Auraskin Gold", "Électrolyse", "Réhaussement de Cil", "Brow Lift"] },
  services: {
    titleA: "Quatre savoir-faire,", titleB: "une exigence.",
    bookCta: "Réserver ce soin",
    chapters: [
      { title: "Laser Diode", accent: "Auraskin Gold", text: "L'épilation définitive nouvelle génération. La machine Auraskin Gold — la plus performante du marché — traite tous les phototypes, rapidement et en toute sécurité." },
      { title: "Électrolyse", accent: "Poil à poil", text: "La méthode définitive historique, idéale pour les poils clairs, blancs ou isolés que le laser ne cible pas. Précision absolue, résultat permanent." },
      { title: "Réhaussement de Cil", accent: "Regard ouvert", text: "Vos cils naturels recourbés et sublimés pendant six à huit semaines. Un regard ouvert dès le réveil, sans mascara." },
      { title: "Brow Lift", accent: "Sourcils structurés", text: "Des sourcils disciplinés, brossés vers le haut et visiblement plus denses. La frame parfaite pour votre regard." },
    ],
  },
  machine: {
    kicker: "La technologie", titleA: "Auraskin", titleB: "Gold.",
    sub: "Tout simplement la meilleure machine laser diode du moment. Chez Nadou Skin, votre peau bénéficie de ce qui se fait de plus avancé — ni plus, ni moins.",
    points: [
      { title: "Puissance Gold", text: "Triple longueur d'onde pour une efficacité maximale sur tous les poils." },
      { title: "Confort glacial", text: "Système de refroidissement saphir : séances quasi indolores." },
      { title: "Tous phototypes", text: "Peaux claires à foncées, traitées en toute sécurité, toute l'année." },
      { title: "Rapidité record", text: "Grande spot size : les jambes complètes en un temps réduit." },
    ],
  },
  journey: {
    kicker: "Laser Diode — le suivi", titleA: "La loupe des", titleB: "résultats.",
    instruction: "Faites glisser la loupe de gauche à droite pour voir l'évolution de la repousse, séance après séance.",
    sessionOf: "Séance {n} sur 10", regrowthLabel: "de repousse estimée",
    skinTone: "Votre phototype de peau :",
    phrases: [
      "Les poils repoussent encore, mais déjà plus fins et plus clairsemés.",
      "La repousse ralentit, les poils reviennent plus doucement.",
      "Les zones commencent visiblement à s'éclaircir.",
      "Moins de la moitié des poils reviennent.",
      "La repousse devient clairsemée et très fine.",
      "La peau reste nette de plus en plus longtemps.",
      "Seuls quelques poils isolés réapparaissent.",
      "La repousse devient exceptionnelle.",
      "Presque plus rien — quelques poils épars au maximum.",
      "Objectif atteint : plus de repousse. Une simple retouche annuelle suffit.",
    ],
    disclaimer: "Estimation indicative avec Auraskin Gold — chaque peau et chaque pilosité réagissent différemment. Un protocole personnalisé est défini lors du diagnostic gratuit.",
  },
  pricing: { kicker: "Les tarifs", titleA: "Une grille", titleB: "claire.", note: "Tarifs par séance.", min: "min" },
  booking: {
    kicker: "Réservation en ligne", titleA: "Vos disponibilités,", titleB: "en direct.",
    sub: "Choisissez votre soin, votre créneau, puis envoyez votre demande. Nadou la confirme personnellement — votre rendez-vous n'est validé qu'après sa confirmation.",
    step1: "Votre soin", step2: "Votre date", step3: "Votre horaire", step4: "Vos coordonnées",
    stepType: "Le type de soin", stepService: "La prestation",
    families: {
      laser: { name: "Laser Diode", tag: "Épilation définitive — Auraskin Gold" },
      electrolyse: { name: "Électrolyse", tag: "Poil à poil, résultat permanent" },
      cil: { name: "Réhaussement de cil", tag: "Courbure naturelle, 6 à 8 semaines" },
      brow: { name: "Brow Lift", tag: "Sourcils structurés et fournis" },
    },
    loading: "Chargement du planning…",
    namePh: "Votre nom", phonePh: "Votre téléphone", msgPh: "Un message pour Nadou ? (optionnel)",
    submit: "Envoyer ma demande", recap: "Récapitulatif :", at: "à",
    successTitle: "Demande enregistrée",
    successText: "Dernière étape : envoyez la demande sur WhatsApp pour que Nadou la confirme.",
    successWa: "Envoyer sur WhatsApp",
    successNote: "Le rendez-vous est accepté uniquement après confirmation de Nadou.",
    errorSlot: "Ce créneau vient d'être pris, choisissez-en un autre",
    errorAvail: "Impossible de charger les disponibilités",
  },
  testimonials: {
    kicker: "Elles en parlent", titleA: "Leur peau,", titleB: "leurs mots.",
    items: [
      { name: "Sarah M.", service: "Jambes complètes", text: "Après trois séances avec l'Auraskin Gold, le résultat est déjà bluffant. Nadou prend le temps d'expliquer chaque étape, on se sent en totale confiance." },
      { name: "Yasmine B.", service: "Réhaussement de cil", text: "Mon regard est transformé, naturel et ouvert dès le réveil. Le cadre est apaisant, le soin ultra précis. Je ne peux plus m'en passer." },
      { name: "Laura D.", service: "Brow lift", text: "Des sourcils parfaits pendant des semaines, sans maquillage. Le résultat est exactement ce que je cherchais — structuré mais naturel." },
    ],
  },
  footer: {
    desc: "Studio d'esthétique spécialisé en épilation définitive et soins du regard. Chaque rendez-vous est confirmé personnellement.",
    contact: "Contact", hours: "Horaires", closed: "Fermé",
    rights: "Tous droits réservés", pro: "Espace pro",
  },
  days: ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"],
  daysShort: ["lun", "mar", "mer", "jeu", "ven", "sam", "dim"],
  months: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
  confirm: {
    kicker: "Demande de rendez-vous", date: "Date", client: "Cliente", phone: "Téléphone", price: "Tarif", message: "Message",
    pending: "En attente de votre décision", confirmed: "Rendez-vous confirmé", refused: "Rendez-vous refusé", cancelled: "Rendez-vous annulé",
    confirmBtn: "Confirmer", refuseBtn: "Refuser", notFound: "Ce rendez-vous est introuvable ou le lien a expiré.", back: "← Retour au site", loading: "Chargement…",
  },
  presence: {
    kicker: "Confirmation de présence", btn: "Je confirme ma présence",
    doneTitle: "Merci {name} !",
    doneText: "Votre présence est confirmée pour votre rendez-vous",
    notFound: "Ce rendez-vous est introuvable ou le lien a expiré.", back: "← Retour au site", loading: "Chargement…",
  },
  cat: { "Laser Diode — Auraskin Gold": "Laser Diode — Auraskin Gold", "Électrolyse": "Électrolyse", "Regard": "Regard" },
  reviews: {
    cta: "Donner votre avis",
    formTitle: "Votre avis compte",
    namePh: "Votre prénom",
    servicePh: "Prestation concernée",
    textPh: "Racontez votre expérience…",
    ratingLabel: "Votre note",
    submit: "Envoyer mon avis",
    success: "Merci ! Votre avis sera visible par toutes les visiteuses après validation par Nadou.",
    pendingBadge: "En attente de validation — visible uniquement par vous pour le moment",
    error: "Merci de renseigner votre prénom, votre note et votre avis",
  },
  svcName: {
    "Lèvre supérieure": "Lèvre supérieure", "Visage complet": "Visage complet", "Aisselles": "Aisselles",
    "Maillot simple": "Maillot simple", "Demi-jambes": "Demi-jambes", "Jambes complètes": "Jambes complètes",
    "Électrolyse — 15 min": "Électrolyse — 15 min", "Électrolyse — 30 min": "Électrolyse — 30 min",
    "Réhaussement de cil": "Réhaussement de cil", "Brow lift": "Brow lift", "Duo Cils + Sourcils": "Duo Cils + Sourcils",
  },
  svcDesc: {
    "Lèvre supérieure": "Épilation définitive du duvet du visage, douce et rapide.",
    "Visage complet": "Traitement complet du visage pour une peau nette et durable.",
    "Aisselles": "La zone la plus demandée, résultats visibles dès les premières séances.",
    "Maillot simple": "Épilation du maillot classique, en toute discrétion.",
    "Demi-jambes": "Des jambes douces durablement, sans rasoir ni cire.",
    "Jambes complètes": "Le forfait jambes intégral pour un résultat parfait.",
    "Électrolyse — 15 min": "Épilation définitive poil à poil, idéale pour les poils clairs ou isolés.",
    "Électrolyse — 30 min": "Séance longue pour traiter une zone plus étendue.",
    "Réhaussement de cil": "Courbure naturelle et regard ouvert pendant 6 à 8 semaines.",
    "Brow lift": "Des sourcils disciplinés, structurés et visiblement plus fournis.",
    "Duo Cils + Sourcils": "Le regard complet : réhaussement de cil et brow lift en une séance.",
  },
};

const en = {
  nav: { soins: "Treatments", machine: "Auraskin Gold", resultats: "Results", tarifs: "Prices", dispos: "Availability", contact: "Contact", reserver: "Book now" },
  hero: {
    kicker: "Aesthetic Centre — Hair Removal & Eye Care",
    l1: "Reveal", l2: "your skin,", l3: "without compromise.",
    sub: "Permanent laser hair removal with Auraskin Gold — the absolute benchmark right now — electrolysis, lash lift and brow lift, in a cocoon of softness.",
    cta1: "Book an appointment", cta2: "Discover treatments",
    badgeTitle: "Auraskin Gold", badgeSub: "The best machine of the moment",
  },
  marquee: { items: ["Diode Laser Hair Removal", "Auraskin Gold", "Electrolysis", "Lash Lift", "Brow Lift"] },
  services: {
    titleA: "Four crafts,", titleB: "one standard.",
    bookCta: "Book this treatment",
    chapters: [
      { title: "Diode Laser", accent: "Auraskin Gold", text: "Next-generation permanent hair removal. The Auraskin Gold machine — the most powerful on the market — treats all skin types, quickly and safely." },
      { title: "Electrolysis", accent: "Hair by hair", text: "The historic permanent method, ideal for light, white or isolated hairs that laser cannot target. Absolute precision, permanent results." },
      { title: "Lash Lift", accent: "Open eyes", text: "Your natural lashes lifted and enhanced for six to eight weeks. An open gaze from the moment you wake up, no mascara needed." },
      { title: "Brow Lift", accent: "Structured brows", text: "Disciplined brows, brushed upwards and visibly fuller. The perfect frame for your eyes." },
    ],
  },
  machine: {
    kicker: "The technology", titleA: "Auraskin", titleB: "Gold.",
    sub: "Quite simply the best diode laser machine of the moment. At Nadou Skin, your skin benefits from the most advanced technology available — nothing less.",
    points: [
      { title: "Gold power", text: "Triple wavelength for maximum effectiveness on all hair types." },
      { title: "Icy comfort", text: "Sapphire cooling system: virtually painless sessions." },
      { title: "All skin types", text: "Light to dark skin, treated safely, all year round." },
      { title: "Record speed", text: "Large spot size: full legs in record time." },
    ],
  },
  journey: {
    kicker: "Diode Laser — your progress", titleA: "The results", titleB: "magnifier.",
    instruction: "Drag the magnifier from left to right to see regrowth fade away, session after session.",
    sessionOf: "Session {n} of 10", regrowthLabel: "estimated regrowth",
    skinTone: "Your skin phototype:",
    phrases: [
      "Hair still grows back, but already finer and sparser.",
      "Regrowth slows, hair comes back more gently.",
      "Areas are visibly starting to clear.",
      "Less than half of the hair comes back.",
      "Regrowth becomes sparse and very fine.",
      "Skin stays smooth for longer and longer.",
      "Only a few isolated hairs reappear.",
      "Regrowth becomes truly exceptional.",
      "Almost nothing left — a few stray hairs at most.",
      "Goal reached: no more regrowth. A simple yearly touch-up is enough.",
    ],
    disclaimer: "Indicative estimate with Auraskin Gold — every skin and hair type reacts differently. A personalised plan is defined during the free consultation.",
  },
  pricing: { kicker: "Prices", titleA: "Honest,", titleB: "clear pricing.", note: "Prices per session.", min: "min" },
  booking: {
    kicker: "Online booking", titleA: "Real-time", titleB: "availability.",
    sub: "Choose your treatment, your slot, then send your request. Nadou confirms it personally — your appointment is only final after her confirmation.",
    step1: "Your treatment", step2: "Your date", step3: "Your time", step4: "Your details",
    stepType: "Treatment type", stepService: "The treatment",
    families: {
      laser: { name: "Diode Laser", tag: "Permanent hair removal — Auraskin Gold" },
      electrolyse: { name: "Electrolysis", tag: "Hair by hair, permanent results" },
      cil: { name: "Lash Lift", tag: "Natural curl for 6 to 8 weeks" },
      brow: { name: "Brow Lift", tag: "Structured, fuller brows" },
    },
    loading: "Loading schedule…",
    namePh: "Your name", phonePh: "Your phone number", msgPh: "A message for Nadou? (optional)",
    submit: "Send my request", recap: "Summary:", at: "at",
    successTitle: "Request received",
    successText: "Last step: send the request on WhatsApp so Nadou can confirm it.",
    successWa: "Send on WhatsApp",
    successNote: "The appointment is only accepted after Nadou's confirmation.",
    errorSlot: "This slot was just taken, please pick another one",
    errorAvail: "Unable to load availability",
  },
  testimonials: {
    kicker: "What they say", titleA: "Their skin,", titleB: "their words.",
    items: [
      { name: "Sarah M.", service: "Jambes complètes", text: "After three sessions with the Auraskin Gold, the result is already stunning. Nadou takes time to explain every step — you feel completely confident." },
      { name: "Yasmine B.", service: "Réhaussement de cil", text: "My gaze is transformed, natural and open from the moment I wake up. The setting is soothing, the treatment ultra precise. I can't do without it anymore." },
      { name: "Laura D.", service: "Brow lift", text: "Perfect brows for weeks, without any makeup. The result is exactly what I was looking for — structured yet natural." },
    ],
  },
  footer: {
    desc: "Aesthetic studio specialised in permanent hair removal and eye treatments. Every appointment is confirmed personally.",
    contact: "Contact", hours: "Opening hours", closed: "Closed",
    rights: "All rights reserved", pro: "Pro area",
  },
  days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
  daysShort: ["mon", "tue", "wed", "thu", "fri", "sat", "sun"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  confirm: {
    kicker: "Appointment request", date: "Date", client: "Client", phone: "Phone", price: "Price", message: "Message",
    pending: "Awaiting your decision", confirmed: "Appointment confirmed", refused: "Appointment declined", cancelled: "Appointment cancelled",
    confirmBtn: "Confirm", refuseBtn: "Decline", notFound: "This appointment was not found or the link has expired.", back: "← Back to site", loading: "Loading…",
  },
  presence: {
    kicker: "Attendance confirmation", btn: "I confirm my attendance",
    doneTitle: "Thank you {name}!",
    doneText: "Your attendance is confirmed for your appointment",
    notFound: "This appointment was not found or the link has expired.", back: "← Back to site", loading: "Loading…",
  },
  cat: { "Laser Diode — Auraskin Gold": "Diode Laser — Auraskin Gold", "Électrolyse": "Electrolysis", "Regard": "Eyes & Brows" },
  reviews: {
    cta: "Share your review",
    formTitle: "Your review matters",
    namePh: "Your first name",
    servicePh: "Treatment concerned",
    textPh: "Tell us about your experience…",
    ratingLabel: "Your rating",
    submit: "Submit my review",
    success: "Thank you! Your review will be visible to all visitors after Nadou approves it.",
    pendingBadge: "Pending approval — only visible to you for now",
    error: "Please fill in your name, rating and review",
  },
  svcName: {
    "Lèvre supérieure": "Upper lip", "Visage complet": "Full face", "Aisselles": "Underarms",
    "Maillot simple": "Bikini line", "Demi-jambes": "Lower legs", "Jambes complètes": "Full legs",
    "Électrolyse — 15 min": "Electrolysis — 15 min", "Électrolyse — 30 min": "Electrolysis — 30 min",
    "Réhaussement de cil": "Lash lift", "Brow lift": "Brow lift", "Duo Cils + Sourcils": "Lash + Brow duo",
  },
  svcDesc: {
    "Lèvre supérieure": "Permanent removal of facial fuzz, gentle and fast.",
    "Visage complet": "Complete facial treatment for clear, lasting skin.",
    "Aisselles": "The most requested area, visible results from the first sessions.",
    "Maillot simple": "Classic bikini line hair removal, in complete discretion.",
    "Demi-jambes": "Lastingly soft legs, no razor or wax needed.",
    "Jambes complètes": "The complete legs package for a perfect result.",
    "Électrolyse — 15 min": "Permanent hair-by-hair removal, ideal for light or isolated hairs.",
    "Électrolyse — 30 min": "Longer session to treat a wider area.",
    "Réhaussement de cil": "Natural curl and an open gaze for 6 to 8 weeks.",
    "Brow lift": "Disciplined, structured and visibly fuller brows.",
    "Duo Cils + Sourcils": "The complete gaze: lash lift and brow lift in one session.",
  },
};

const nl = {
  nav: { soins: "Behandelingen", machine: "Auraskin Gold", resultats: "Resultaten", tarifs: "Prijzen", dispos: "Beschikbaarheid", contact: "Contact", reserver: "Reserveren" },
  hero: {
    kicker: "Schoonheidscentrum — Ontharing & Oogverzorging",
    l1: "Onthul", l2: "jouw huid,", l3: "zonder compromis.",
    sub: "Definitieve laserontharing met Auraskin Gold — dé referentie van dit moment — elektrolyse, wimperlifting en brow lift, in een cocon van zachtheid.",
    cta1: "Afspraak boeken", cta2: "Ontdek de behandelingen",
    badgeTitle: "Auraskin Gold", badgeSub: "De beste machine van dit moment",
  },
  marquee: { items: ["Diode Laserontharing", "Auraskin Gold", "Elektrolyse", "Wimperlifting", "Brow Lift"] },
  services: {
    titleA: "Vier vakdisciplines,", titleB: "één standaard.",
    bookCta: "Deze behandeling boeken",
    chapters: [
      { title: "Diode Laser", accent: "Auraskin Gold", text: "Definitieve ontharing van de nieuwe generatie. De Auraskin Gold — de krachtigste machine op de markt — behandelt alle huidtypes, snel en veilig." },
      { title: "Elektrolyse", accent: "Haar per haar", text: "De klassieke definitieve methode, ideaal voor lichte, witte of losse haren die de laser niet kan bereiken. Absolute precisie, permanent resultaat." },
      { title: "Wimperlifting", accent: "Open blik", text: "Je natuurlijke wimpers gelift en gesublimeerd voor zes tot acht weken. Een open blik vanaf het ontwaken, zonder mascara." },
      { title: "Brow Lift", accent: "Gestructureerde wenkbrauwen", text: "Gedisciplineerde wenkbrauwen, omhoog gekamd en zichtbaar voller. Het perfecte kader voor je blik." },
    ],
  },
  machine: {
    kicker: "De technologie", titleA: "Auraskin", titleB: "Gold.",
    sub: "Simpelweg de beste diodelaser van dit moment. Bij Nadou Skin profiteert je huid van de meest geavanceerde technologie — niets minder.",
    points: [
      { title: "Gold-kracht", text: "Drie golflengtes voor maximale effectiviteit op elk haartype." },
      { title: "IJzig comfort", text: "Saffier-koelsysteem: vrijwel pijnloze sessies." },
      { title: "Alle huidtypes", text: "Lichte tot donkere huid, het hele jaar veilig behandeld." },
      { title: "Recordsnelheid", text: "Grote spotgrootte: volledige benen in recordtijd." },
    ],
  },
  journey: {
    kicker: "Diode laser — je voortgang", titleA: "Het resultaten-", titleB: "vergrootglas.",
    instruction: "Sleep het vergrootglas van links naar rechts om de haargroei te zien afnemen, sessie na sessie.",
    sessionOf: "Sessie {n} van 10", regrowthLabel: "geschatte haargroei",
    skinTone: "Jouw huidfototype:",
    phrases: [
      "De haren groeien nog terug, maar al fijner en schaarser.",
      "De haargroei vertraagt, de haren komen zachter terug.",
      "De zones beginnen zichtbaar rustiger te worden.",
      "Minder dan de helft van de haren komt terug.",
      "De haargroei wordt schaars en zeer fijn.",
      "De huid blijft steeds langer glad.",
      "Slechts enkele losse haartjes verschijnen.",
      "Haargroei wordt echt uitzonderlijk.",
      "Vrijwel niets meer — hooguit enkele losse haartjes.",
      "Doel bereikt: geen haargroei meer. Een jaarlijkse bijwerking volstaat.",
    ],
    disclaimer: "Indicatieve schatting met Auraskin Gold — elke huid en beharing reageert anders. Een persoonlijk plan wordt opgesteld tijdens de gratis diagnose.",
  },
  pricing: { kicker: "Prijzen", titleA: "Een helder", titleB: "prijsoverzicht.", note: "Prijzen per sessie.", min: "min" },
  booking: {
    kicker: "Online boeken", titleA: "Actuele", titleB: "beschikbaarheid.",
    sub: "Kies je behandeling en je moment, en verstuur je aanvraag. Nadou bevestigt persoonlijk — je afspraak is pas definitief na haar bevestiging.",
    step1: "Je behandeling", step2: "Je datum", step3: "Je tijdstip", step4: "Je gegevens",
    stepType: "Type behandeling", stepService: "De behandeling",
    families: {
      laser: { name: "Diode Laser", tag: "Definitieve ontharing — Auraskin Gold" },
      electrolyse: { name: "Elektrolyse", tag: "Haar per haar, permanent resultaat" },
      cil: { name: "Wimperlifting", tag: "Natuurlijke krul, 6 tot 8 weken" },
      brow: { name: "Brow Lift", tag: "Gestructureerde, vollere wenkbrauwen" },
    },
    loading: "Planning laden…",
    namePh: "Je naam", phonePh: "Je telefoonnummer", msgPh: "Een bericht voor Nadou? (optioneel)",
    submit: "Verstuur mijn aanvraag", recap: "Samenvatting:", at: "om",
    successTitle: "Aanvraag ontvangen",
    successText: "Laatste stap: verstuur de aanvraag via WhatsApp zodat Nadou ze kan bevestigen.",
    successWa: "Verstuur via WhatsApp",
    successNote: "De afspraak is pas definitief na bevestiging van Nadou.",
    errorSlot: "Dit moment is net ingenomen, kies een ander",
    errorAvail: "Beschikbaarheid laden mislukt",
  },
  testimonials: {
    kicker: "Wat zij zeggen", titleA: "Hun huid,", titleB: "hun woorden.",
    items: [
      { name: "Sarah M.", service: "Jambes complètes", text: "Na drie sessies met de Auraskin Gold is het resultaat al indrukwekkend. Nadou neemt de tijd om elke stap uit te leggen — je voelt je volledig op je gemak." },
      { name: "Yasmine B.", service: "Réhaussement de cil", text: "Mijn blik is getransformeerd, natuurlijk en open vanaf het ontwaken. De sfeer is rustgevend, de behandeling uiterst precies. Ik kan er niet meer zonder." },
      { name: "Laura D.", service: "Brow lift", text: "Wekenlang perfecte wenkbrauwen, zonder make-up. Het resultaat is precies wat ik zocht — gestructureerd maar natuurlijk." },
    ],
  },
  footer: {
    desc: "Esthetische studio gespecialiseerd in definitieve ontharing en oogbehandelingen. Elke afspraak wordt persoonlijk bevestigd.",
    contact: "Contact", hours: "Openingsuren", closed: "Gesloten",
    rights: "Alle rechten voorbehouden", pro: "Pro-omgeving",
  },
  days: ["Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag", "Zondag"],
  daysShort: ["ma", "di", "wo", "do", "vr", "za", "zo"],
  months: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"],
  confirm: {
    kicker: "Afspraakaanvraag", date: "Datum", client: "Klant", phone: "Telefoon", price: "Prijs", message: "Bericht",
    pending: "In afwachting van je beslissing", confirmed: "Afspraak bevestigd", refused: "Afspraak geweigerd", cancelled: "Afspraak geannuleerd",
    confirmBtn: "Bevestigen", refuseBtn: "Weigeren", notFound: "Deze afspraak werd niet gevonden of de link is verlopen.", back: "← Terug naar de site", loading: "Laden…",
  },
  presence: {
    kicker: "Aanwezigheid bevestigen", btn: "Ik bevestig mijn aanwezigheid",
    doneTitle: "Bedankt {name}!",
    doneText: "Je aanwezigheid is bevestigd voor je afspraak",
    notFound: "Deze afspraak werd niet gevonden of de link is verlopen.", back: "← Terug naar de site", loading: "Laden…",
  },
  cat: { "Laser Diode — Auraskin Gold": "Diodelaser — Auraskin Gold", "Électrolyse": "Elektrolyse", "Regard": "Ogen & Wenkbrauwen" },
  reviews: {
    cta: "Deel je ervaring",
    formTitle: "Jouw ervaring telt",
    namePh: "Je voornaam",
    servicePh: "Betreffende behandeling",
    textPh: "Vertel over je ervaring…",
    ratingLabel: "Jouw score",
    submit: "Verstuur mijn review",
    success: "Bedankt! Je review wordt zichtbaar voor alle bezoekers na goedkeuring door Nadou.",
    pendingBadge: "Wacht op goedkeuring — nu alleen zichtbaar voor jou",
    error: "Vul je naam, score en review in",
  },
  svcName: {
    "Lèvre supérieure": "Bovenlip", "Visage complet": "Volledig gelaat", "Aisselles": "Oksels",
    "Maillot simple": "Bikinilijn", "Demi-jambes": "Onderbenen", "Jambes complètes": "Volledige benen",
    "Électrolyse — 15 min": "Elektrolyse — 15 min", "Électrolyse — 30 min": "Elektrolyse — 30 min",
    "Réhaussement de cil": "Wimperlifting", "Brow lift": "Brow lift", "Duo Cils + Sourcils": "Duo Wimpers + Wenkbrauwen",
  },
  svcDesc: {
    "Lèvre supérieure": "Definitieve verwijdering van gezichtsbeharing, zacht en snel.",
    "Visage complet": "Volledige gelaatsbehandeling voor een zuivere, duurzame huid.",
    "Aisselles": "De meest gevraagde zone, zichtbaar resultaat vanaf de eerste sessies.",
    "Maillot simple": "Klassieke bikinilijn ontharing, in alle discretie.",
    "Demi-jambes": "Duurzaam zachte benen, zonder scheermes of hars.",
    "Jambes complètes": "Het complete benenpakket voor een perfect resultaat.",
    "Électrolyse — 15 min": "Definitieve ontharing haar per haar, ideaal voor lichte of losse haren.",
    "Électrolyse — 30 min": "Langere sessie voor een grotere zone.",
    "Réhaussement de cil": "Natuurlijke krul en een open blik voor 6 tot 8 weken.",
    "Brow lift": "Gedisciplineerde, gestructureerde en zichtbaar vollere wenkbrauwen.",
    "Duo Cils + Sourcils": "De complete blik: wimperlifting en brow lift in één sessie.",
  },
};

const dicts = { fr, en, nl };

const LangContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("nadou_lang") || "fr");
  const setLang = (l) => {
    localStorage.setItem("nadou_lang", l);
    setLangState(l);
  };
  const t = (path, vars) => {
    const get = (d) => path.split(".").reduce((o, k) => (o != null && o[k] !== undefined ? o[k] : undefined), d);
    let val = get(dicts[lang]) ?? get(fr) ?? path;
    if (vars && typeof val === "string") {
      Object.entries(vars).forEach(([k, v]) => { val = val.replace(`{${k}}`, v); });
    }
    return val;
  };
  const tf = (path, fallback) => {
    const val = t(path);
    return val === path ? fallback : val;
  };
  return <LangContext.Provider value={{ lang, setLang, t, tf }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);

export const FR_DAYS_IDX = fr.days.map((d) => d.toLowerCase());
export const FR_MONTHS_IDX = fr.months.map((m) => m.toLowerCase());
